<header class="header">
    <button class="menu-toggle" (click)="toggleMenu()">☰</button>

    <div class="logo">
        <a href="#" style="text-decoration: none;">
            <img src="/obras/paleta/logo.png" alt="MINUS Logo" class="logo-image">
        </a>
    </div>

    <nav class="nav" [class.active]="menuOpen">
        <ul>
            <li><a href="#">{{ translationService.getTranslation('Sobre Nosotros') }}</a></li>
            <li><a href="#">{{ translationService.getTranslation('Noticias') }}</a></li>
            <li><a href="/reader">{{ translationService.getTranslation('© Monthly Awards') }}</a></li>
            <li><a href="/categorias">{{ translationService.getTranslation('Géneros') }}</a></li>
            <li *ngIf="hasRole"><a href="/perfil">{{ translationService.getTranslation('Mi perfil') }}</a></li>
        </ul>
        <div class="search-upload">
            <input type="text" [placeholder]="translationService.getTranslation('Keyword')">
            <button class="search-btn">🔍</button>
        </div>
        <div class="upload-lang-container">
            <button class="upload-btn" (click)="navigateToFormulario()">{{ translationService.getTranslation('Subir obra') }}</button>
            <select class="lang-select" (change)="changeLanguage($event)" [value]="currentLanguage">
                <option value="es">Español</option>
                <option value="en">English</option>
            </select>
        </div>
    </nav>

    <!-- Botón de Cerrar Sesión SOLO si el usuario tiene rol -->
    <div *ngIf="hasRole" class="auth-links-container">
        <button class="logout-btn" (click)="logout()">
            {{ translationService.getTranslation('Cerrar Sesión') }}
        </button>
    </div>

    <div class="user-icon-container" *ngIf="hasRole">
        <a [routerLink]="['/perfil/user', userId]">
            <div class="user-icon">👤</div>
        </a>
    </div>

    <div class="auth-links-container" *ngIf="!hasRole">
        <a href="/login">{{ translationService.getTranslation('Login') }}</a>
        <a href="/signup">{{ translationService.getTranslation('Sign Up') }}</a>
    </div>
</header>
